import styled from 'styled-components';

import { colorWhite, colorBlueGray, fontFamilyPrimary } from 'styles';

export const Button = styled.button`
  position: relative;
  background: ${colorWhite};
  padding: 8px 8px 4px 8px;
  font-family: ${fontFamilyPrimary};
  font-size: 12px;
  line-height: 16px;
  font-weight: normal;
  border-radius: 4px;
  border: 1px solid ${colorBlueGray};
  cursor: pointer;
  transition: color 0.3s, background-color 0.3s, border-color 0.3s,
    box-shadow 0.3s;

  &:active,
  &.focus-visible,
  &:focus {
    text-decoration: none;
  }

  &:disabled {
    border-color: #ececec;
  }
`;

export default Button;
